import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { HomeComponent } from './home/home.component';
import { MsalGuard } from '@azure/msal-angular';
import { LaboratorioComponent } from './laboratorio/laboratorio.component';
import { LaboratorioLibreComponent } from './laboratorio_libre/laboratorio_libre.component';

const routes: Routes = [
  {
    path: 'laboratorio',
    component: LaboratorioComponent,
    canActivate: [
      MsalGuard
    ]
  },
  {
    path: 'laboratorio_libre',
    component: LaboratorioLibreComponent
  },
  {
    path: '',
    component: HomeComponent
  },
  {
    path: 'home',
    component: HomeComponent
  },
  {
    // Needed for hash routing
    path: 'code',
    component: HomeComponent
  },
  {
    // Needed for Error routing
    path: 'error',
    component: HomeComponent
  }
];

const isIframe = window !== window.parent && !window.opener;

@NgModule({
  imports: [RouterModule.forRoot(routes, {
    useHash: true,
    // Don't perform initial navigation in iframes
    initialNavigation: !isIframe ? 'enabled' : 'disabled'
  })],
  exports: [RouterModule]
})
export class AppRoutingModule { }
